// TOUR-21 — Manufacturing desk inventory + WAC entry (ShedCor pilot).

import type { FireflyTourArtifact } from "../tourTypes";

export const MFG_INVENTORY_TOUR_ID = "tour-mfg-inventory";

export const MFG_INVENTORY_TOUR: FireflyTourArtifact = {
  id: MFG_INVENTORY_TOUR_ID,
  version: 1,
  defaultIntent: "teaching",
  intents: [
    "manufacturing inventory tour",
    "inventory tour",
    "how do i enter material costs",
    "material costs tour",
    "receive materials",
    "update wac",
    "post a receive",
    "weighted average cost tour",
  ],
  bucketRelevance: ["manufacturing"],
  requiredRoles: ["manufacturing", "platform_owner", "platform_admin", "platform_dev"],
  steps: [
    {
      id: "nav-inventory",
      target: {
        mode: "mfgInventory",
        anchorId: "mode-nav-mfgInventory",
        scrollIntoView: true,
      },
      deferModeNavigation: true,
      skipWhenCurrentMode: "mfgInventory",
      copy: {
        title: "Open Inventory",
        body: "Materials catalog, on-hand quantities, and weighted-average costs live here. Tap Inventory in the Manufacturing bucket (sidebar or bottom bar).",
      },
      waitForClick: true,
    },
    {
      id: "inventory-surface",
      target: {
        mode: "mfgInventory",
        anchorId: "mfg-inventory-surface",
        scrollIntoView: true,
      },
      copy: {
        title: "Inventory workspace",
        body: "Left column lists materials and receipts; right column posts receive lines that update WAC. The snapshot shows total inventory value after costing runs.",
      },
      advanceOn: "next_button",
    },
    {
      id: "materials-list",
      target: {
        mode: "mfgInventory",
        anchorId: "mfg-materials-list",
        scrollIntoView: true,
      },
      copy: {
        title: "Materials and WAC",
        body: "Each row shows on-hand quantity and current WAC per unit. When Firefly flags stale material costs, Review in Inventory opens this same list — post a receive to refresh costs.",
      },
      advanceOn: "next_button",
    },
    {
      id: "receive-lines",
      target: {
        mode: "mfgInventory",
        anchorId: "mfg-receive-lines",
        scrollIntoView: true,
      },
      copy: {
        title: "Receive lines",
        body: "Pick a material, enter qty received and unit cost, then add more lines if needed. WAC recalculates when you post — there is no separate inline WAC edit field.",
      },
      advanceOn: "next_button",
    },
    {
      id: "receive-post",
      target: {
        mode: "mfgInventory",
        anchorId: "mfg-receive-post",
        scrollIntoView: true,
      },
      copy: {
        title: "Post receipt",
        body: "Post receipt writes cost entries and updates weighted-average cost for each line. You perform this step yourself — the tour will not post on your behalf.",
      },
      destructive: true,
    },
    {
      id: "ask-firefly",
      target: { mode: "mfgInventory", anchorId: "ask-firefly", scrollIntoView: true },
      copy: {
        title: "Ask Firefly anytime",
        body: "Vendor receipt OCR lives on the Receipts tab. Changelog shows every receive and adjustment. Ask Firefly anytime for plants, units, or logistics tours.",
      },
      advanceOn: "next_button",
    },
  ],
};
